import React, { useState } from 'react';
import { MdArrowBack, MdMoreVert, MdAdd } from 'react-icons/md';

const ACTIVE_PAYMENTS = [
  { id: 1, merchant: 'Netflix',         amount: '$17.99',  freq: 'Monthly', next: 'Apr 1, 2026' },
  { id: 2, merchant: 'Rogers Wireless', amount: '$89.00',  freq: 'Monthly', next: 'Apr 3, 2026' },
  { id: 3, merchant: 'TD Visa',         amount: '$200.00', freq: 'Monthly', next: 'Apr 5, 2026', note: 'minimum payment' },
  { id: 4, merchant: 'Hydro One',       amount: '$142.00', freq: 'Monthly', next: 'Apr 8, 2026' },
  { id: 5, merchant: 'Spotify',         amount: '$11.99',  freq: 'Monthly', next: 'Apr 12, 2026' },
  { id: 6, merchant: 'iCloud Storage',  amount: '$3.99',   freq: 'Monthly', next: 'Apr 14, 2026' },
];

const PENDING_PAYMENTS = [
  { id: 7, merchant: 'Amazon Prime', amount: '$14.99', freq: 'Monthly', next: 'Pending approval' },
];

const PreAuthorizedScreen = ({ onNavigate, onBack }) => {
  const [openMenu, setOpenMenu] = useState(null);

  const handleManage = (id, e) => {
    e.stopPropagation();
    setOpenMenu(openMenu === id ? null : id);
  };

  const closeMenu = () => setOpenMenu(null);

  const PaymentRow = ({ item, isPending }) => (
    <div className="pre-auth-row" onClick={closeMenu}>
      <div className="pre-auth-icon-wrap" style={{ background: isPending ? 'var(--bg-light-gray)' : 'rgba(0,138,62,0.1)' }}>
        <span style={{ fontSize: 16 }}>{isPending ? '⏳' : '🔄'}</span>
      </div>
      <div className="pre-auth-info">
        <div className="pre-auth-merchant">{item.merchant}</div>
        <div className="pre-auth-meta">{item.freq} · Next: {item.next}{item.note ? ` · ${item.note}` : ''}</div>
      </div>
      <div className="pre-auth-right">
        <div className="pre-auth-amount">{item.amount}</div>
        <div style={{ position: 'relative' }}>
          <button className={`pre-auth-manage-chip${isPending ? ' pending' : ''}`} onClick={(e) => handleManage(item.id, e)}>
            {isPending ? 'Pending' : 'Manage'} <MdMoreVert size={13} style={{ marginLeft: 2 }} />
          </button>
          {openMenu === item.id && (
            <div className="pre-auth-popover">
              <button className="pre-auth-popover-item" onClick={() => { alert('Pause — coming soon'); setOpenMenu(null); }}>⏸ Pause</button>
              <button className="pre-auth-popover-item danger" onClick={() => { alert('Cancel — coming soon'); setOpenMenu(null); }}>✕ Cancel</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="screen bh-flow" onClick={closeMenu}>
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack || (() => onNavigate('home'))} aria-label="Back to home">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Pre-Authorized Payments</h1>
        </div>
      </header>

      <div className="scroll-content gray-bg">

        <div className="pre-auth-summary-bar">
          <div className="pre-auth-summary-item">
            <span className="pre-auth-summary-val">{ACTIVE_PAYMENTS.length}</span>
            <span className="pre-auth-summary-label">Active</span>
          </div>
          <div className="pre-auth-summary-divider" />
          <div className="pre-auth-summary-item">
            <span className="pre-auth-summary-val">$464.97</span>
            <span className="pre-auth-summary-label">Monthly Total</span>
          </div>
          <div className="pre-auth-summary-divider" />
          <div className="pre-auth-summary-item">
            <span className="pre-auth-summary-val" style={{ color: '#f5a623' }}>{PENDING_PAYMENTS.length}</span>
            <span className="pre-auth-summary-label">Pending</span>
          </div>
        </div>

        <div className="pre-auth-section-label">Active</div>
        <div className="emt-section" style={{ marginTop: 0, padding: 0 }}>
          {ACTIVE_PAYMENTS.map(item => <PaymentRow key={item.id} item={item} isPending={false} />)}
        </div>

        <div className="pre-auth-section-label">Pending Approval</div>
        <div className="emt-section" style={{ marginTop: 0, padding: 0 }}>
          {PENDING_PAYMENTS.map(item => <PaymentRow key={item.id} item={item} isPending={true} />)}
        </div>

        <button className="pre-auth-add-btn" onClick={() => alert('Add new pre-authorized payment — coming soon')}>
          <MdAdd size={18} style={{ marginRight: 6 }} /> Add New Pre-Authorized Payment
        </button>

        <div style={{ height: 16 }} />
      </div>
    </div>
  );
};

export default PreAuthorizedScreen;
